import { render, staticRenderFns } from "./StickyNotesBoard.vue?vue&type=template&id=b0e000e4&scoped=true"
import script from "./StickyNotesBoard.vue?vue&type=script&lang=js"
export * from "./StickyNotesBoard.vue?vue&type=script&lang=js"
import style0 from "./StickyNotesBoard.vue?vue&type=style&index=0&id=b0e000e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e000e4",
  null
  
)

export default component.exports